import { Injectable, signal } from '@angular/core';

// Apis
import { CmsMenuApi } from '@core/api/cms/cms-menu.api';

// Models
import { CmsMenuItem } from '@core/models/cms/cms-menu.model';

/**
 * Service du menu CMS public — met en cache les entrées par mandant.
 */
@Injectable({ providedIn: 'root' })
export class CmsMenuService {
	readonly data = signal<CmsMenuItem[] | null>(null);
	readonly loading = signal(false);

	private currentNomdt?: number;

	constructor(private api: CmsMenuApi) {}

	load(nomdt: number): void {
		if (this.loading()) return;
		if (this.data() && this.currentNomdt === nomdt) return;

		this.currentNomdt = nomdt;
		this.loading.set(true);
		this.api.getMenus(nomdt).subscribe({
			next: (response) => {
				this.data.set(response?.data ?? []);
				this.loading.set(false);
			},
			error: (err) => {
				console.error('Erreur chargement menu CMS', err);
				this.loading.set(false);
			},
		});
	}

	reload(nomdt = this.currentNomdt!): void {
		this.data.set(null);
		this.load(nomdt);
	}

	clear(): void {
		this.data.set(null);
		this.currentNomdt = undefined;
	}
}
